<template>
    <el-dialog
        width='600px'
        :title= "translate('transaction_cancel_modal.title')"
        :visible.sync='show'
        :close-on-click-modal='false'
        :before-close='close'
    >
        <el-form class="content">
            <p>{{ translate('transaction_cancel_modal.cancel_text') }}</p>

            <div style="margin-top: 12px;">
                <el-form-item>
                    <span>{{ translate('transaction_cancel_modal.reason_label') }}</span>
                    <el-input
                        type="textarea"
                        :rows="4"
                        v-model="reason"
                        :placeholder="translate('transaction_cancel_modal.reason_placeholder')"
                        @change="changeReason"
                    />
                </el-form-item>
            </div>

            <div class="actions" style="margin-top: 20px; text-align: right;">
                <el-button @click="close">{{ translate('transaction_cancel_modal.cancel_button') }}</el-button>
                <el-button type="primary" style="margin-left: 10px;" @click="confirmDecision">
                    {{ translate('transaction_cancel_modal.confirm_button') }}
                </el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import NotaFiscalService from '@/services/NotaFiscalService';

export default {
    name: 'warehouseTransactionCancelModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        transaction: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            reason: ''
        };
    },
    mounted() {
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        confirmDecision() {
            if (this.reason !== null) {
                let reasonWithTrim = this.reason.trim();
                if (reasonWithTrim.length < 3) {
                    this.$notify.error({ message: this.translate('transaction_cancel_modal.reason_error_message') });
                    return;
                }
            }
            
            NotaFiscalService.cancelar({
                idTransacao: this.transaction.id,
                justificativa: this.reason
            }).then(() => {
                this.$notify.success({ message: this.translate('transaction_cancel_modal.success_message'), duration: 6000 });
                this.close();
                this.$emit('confirm');
            }).catch((error) => {
                this.$notify.error({ message: this.translate('transaction_cancel_modal.' + error.response.data.message), duration: 6000 });
            });
        },
        close() {
            this.reason = '';
            this.$emit('close');
        }
    }
};
</script>

<style scoped lang="scss">
    
</style>
